<template>
  <section>
    <!--工具条-->
    <!-- <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      style="margin: 20px auto 0px 15px"
    ></toolbar> -->
    <el-row class="Nbut" style="margin: 23px auto 0px 0px">
      <el-select
        v-model="GradeId"
        placeholder="全部"
        id="inputselect"
        @change="onOptionsyear"
        style="width: 200px; margin: 0px auto 10px 15px"
      >
        <el-option
          v-for="item in GradeInfoList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
    </el-row>
    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column> -->
      <el-table-column
        type="index"
        width="80"
        align="center"
        label=" "
      ></el-table-column>
      <el-table-column
        prop="NickName"
        label="姓名"
        width
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="Scores"
        label="分数"
        width
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!-- <el-table-column
        prop="Name"
        label="评论内容"
        width
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>

      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" width align="center">
        <template slot-scope="scope">
          <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span>
        </template>
      </el-table-column> -->
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetStudentScore,
  CommentInfoDelete,
  GetGradeInfo,
  GetTaskProccessAdminByStu,
  AddRecordInfo,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      GradeId: null,
      GradeInfoList: [],
      QuesTionId: null,
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      users: [],
      total: 0,
      page: 1,
      pagesize: 10,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        LinkUrl: [
          { required: true, message: "请输入接口地址", trigger: "blur" },
        ],
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        LinkUrl: [
          { required: true, message: "请输入接口地址", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    onOptionsyear() {
      this.getModules();
    },
    changeStatus() {
      GetGradeInfo().then((res) => {
        if (res.data.success) {
          this.GradeInfoList = res.data.response;
          this.GradeId = this.GradeInfoList[0].Id;
          this.getModules();
        }
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },

    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:MM:ss"
          );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    //获取用户列表
    getModules() {
      let para = {
        PageIndex: this.page,
        PageSize: this.pagesize,
        Id: this.GradeId,
      };
      this.listLoading = true;

      //NProgress.start();
      GetTaskProccessAdminByStu(para).then((res) => {
        if (res.data.success) {
          this.AddRecordInfo("查询", "学分管理-学分管理-查看学生学分列表");

          this.total = res.data.response.dataCount;
          this.users = res.data.response.data;
          this.listLoading = false;
        } else {
          this.total = 0;
          this.users = [];
          this.listLoading = false;
        }

        //NProgress.done();
      });
    },
    //删除
    handleDel(Id) {
      // let row = this.currentRow;
      // // if (!row) {
      // //   this.$message({
      // //     message: "请选择要删除的一行数据！",
      // //     type: "error",
      // //   });

      // //   return;
      // // }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Id: Id };
          CommentInfoDelete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
  },
  mounted() {
    // this.QuesTionId = this.$route.query.Id;
    this.changeStatus();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
